import { useState } from "react";
import { cpfMask, formatarData, phoneMask } from "../../utils/functions";
import Modal from "../../utils/modal";

const UserInfo = ({ userData, showHeader = true }) => {
    const [modal, setModal] = useState(false);
    return (
        <div className="m-4 border border-[#666] p-2 bg-monao relative">
            {
                userData?.city || userData?.street || userData?.postalCode ?
                    <div className="absolute top-0 left-2 m-0 font-bold text-primary text-lg cursor-pointer" onClick={() => setModal(true)}>
                        +
                    </div>
                    : null
            }
            {
                showHeader ?
                    <h2 className="text-center text-lg mb-4">Detalhes do usuário</h2>
                    : null
            }
            <div className="flex gap-10 w-fit m-auto flex-wrap justify-center">
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Nome</p>
                    <p className="m-0 text-lg">{userData?.name}</p>
                </div>
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Email</p>
                    <p className="m-0 text-lg">{userData?.email}</p>
                </div>
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Telefone</p>
                    <p className="m-0 text-lg">{phoneMask(userData?.phone)}</p>
                </div>
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">CPF</p>
                    <p className="m-0 text-lg">{cpfMask(userData?.documentNumber)}</p>
                </div>
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Nascimento</p>
                    <p className="m-0 text-lg">{formatarData(userData?.birth)}</p>
                </div>
            </div>
            {
                modal ?
                    <Modal>
                        <div className="relative">
                            <div className="absolute top-0 right-0 text-primary text-xl font-bold cursor-pointer" onClick={() => setModal(false)}>X</div>
                            <p className="text-lg text-center text-primary mb-4">Endereço cadastrado</p>
                            {
                                userData?.city ?
                                    <p className="text-center mb-2">Cidade: {userData?.city}</p>
                                    : null
                            }
                            {
                                userData?.complement ?
                                    <p className="text-center mb-2">Complemento: {userData?.complement}</p>
                                    : null
                            }
                            {
                                userData?.country ?
                                    <p className="text-center mb-2">País: {userData?.country}</p>
                                    : null
                            }
                            {
                                userData?.district ?
                                    <p className="text-center mb-2">Bairro: {userData?.district}</p>
                                    : null
                            }
                            {
                                userData?.houseNumber ?
                                    <p className="text-center mb-2">Número: {userData?.houseNumber}</p>
                                    : null
                            }
                            {
                                userData?.state ?
                                    <p className="text-center mb-2">Estado: {userData?.state}</p>
                                    : null
                            }
                            {
                                userData?.street ?
                                    <p className="text-center mb-2">Rua: {userData?.street}</p>
                                    : null
                            }
                            {
                                userData?.postalCode ?
                                    <p className="text-center mb-2">CEP: {userData?.postalCode}</p>
                                    : null
                            }
                        </div>
                    </Modal>
                    : null
            }
        </div>
    )
}

export default UserInfo;
